import {IKN15ParseService, KN15ParseError} from './kn15-parse.service';
import {ITranslationTable} from 'angular-translate';

export const kn15ParseValidatorFactory =
    (kn15ParseService: IKN15ParseService,
     $translate: ng.translate.ITranslateService,
     $parse: ng.IParseService) => {
      function formatKN15Error(error: KN15ParseError): string {
        const translation = $translate.instant(
            `KN15_ERRORS_${error.messageId}`);
        if (error.badToken) {
          return `${translation} Bad token: ${error.badToken}.`;
        } else {
          return translation;
        }


      }

      return {
        require: 'ngModel',
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery,
               attr: ng.IAttributes, ngModel: ng.INgModelController) => {
          const errorMessage = $parse(attr['errorMessage']);
          ngModel.$validators['kn15Parser'] = (modelValue, viewValue) => {
            const value = modelValue || viewValue;
            if (!value) {
              return true;
            }
            try {
              kn15ParseService.parse(value);
              return true;
            } catch (error) {
              errorMessage.assign(scope, formatKN15Error(error));
              return false;
            }
          };
        }
      }
    };
kn15ParseValidatorFactory.$inject = ['kn15ParseService', '$translate',
  '$parse'];
export default kn15ParseValidatorFactory;




/** WEBPACK FOOTER **
 ** ./app/operational/input/kn15-telegram/kn15-parse-validator.directive.ts
 **/